import React from "react";
import { ArrowLeft, BookOpenCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

import "./ProgressHeader.css";

export default function ProgressHeader({ moduleItem, onToggleSidebar }) {
    const navigate = useNavigate();
    const progress = moduleItem?.progress || {};
    const progressPercent = Math.max(0, Math.min(100, Number(progress.progressPercent || 0)));

    return (
        <header className="ph-header">
            <div className="ph-header__left">
                <button className="ph-back-btn" onClick={() => navigate("/formation/apprenant/modules")}>
                    <ArrowLeft size={18} />
                    <span>Retour</span>
                </button>

                <div className="ph-header__titles">
                    <h1 className="ph-header__title" title={moduleItem?.nom}>
                        {moduleItem?.nom || "Chargement..."}
                    </h1>
                </div>
            </div>

            <div className="ph-header__right">
                <div className="ph-header__progress">
                    <div className="ph-progress-info">
                        <span className="ph-progress-label">Progression globale</span>
                        <span className="ph-progress-stats">
                            {progress.completedRequiredContentsCount || 0}/{progress.totalRequiredContentsCount || 0} terminés
                        </span>
                    </div>

                    <div className="ph-progress-circle-container" onClick={onToggleSidebar}>
                        <div
                            className="ph-progress-circle"
                            style={{
                                background: `conic-gradient(#2f4595 ${progressPercent}%, #dbe3ee ${progressPercent}%)`,
                            }}
                        >
                            <div className="ph-progress-circle-inner">
                                <BookOpenCheck size={16} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
